module.exports = __webpack_public_path__ + "02_face.25562b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer1/02_face.png
// module id = ueNL
// module chunks = 0